<!-- Login form view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article [ngClass]="theme.getThemeClass()" class="wrapper fadeInDown">
    <div [ngClass]="theme.getThemeClass()" id="formContent">
      <!-- ICON -->
      <nav class="fadeIn first">
        <img class="logo" src="../assets/muirwood-studio.png" />
      </nav>
      <div>
        <h1>{{ "cognitoLoginSignIn" | translate }}</h1>
      </div>
      <!-- LOGIN FORM -->
      <form (ngSubmit)="ctx.onLoginSubmit()">
        <div class="form-group fadeIn second">
          <!-- Input for user email -->
          <input
            type="text"
            id="login"
            [(ngModel)]="ctx.user.email"
            class="form-control"
            name="login"
            placeholder="{{ 'cognitoLoginUsername' | translate }}"
            required
            minlength="4"
            #userName="ngModel"
            autocomplete="off"
          />
          <!-- Input for user password -->
          <div class="password-input">
            <input
              type="{{ ctx.showPassword ? 'text' : 'password' }}"
              id="password"
              [(ngModel)]="ctx.user.password"
              class="form-control"
              name="password"
              placeholder="{{ 'cognitoLoginPassword' | translate }}"
              required
              minlength="4"
              #userPassword="ngModel"
              autocomplete="off"
            />
            <!-- Icon of an eye that show/hide the user password -->
            <span (click)="ctx.togglePasswordVisibility('password')">
              <i
                id="eyeIconPassword"
                style="color: #000"
                class="fa"
                [class.fa-eye-slash]="!ctx.showPassword"
              ></i>
            </span>
          </div>
        </div>
        <!-- Button that submit the form -->
        <input
          type="submit"
          skipLocationChange
          class="fadeIn fourth"
          value="{{ 'cognitoLoginBtnLogIn' | translate }}"
          height="30px"
        />
      </form>
      <!-- RESET PASSWORD -->
      <nav [ngClass]="theme.getThemeClass()" id="formFooter">
        <a
          class="underlineHover"
          href="javascript:void(0)"
          (click)="ctx.onForgotPasswordClick()"
        >
          {{ "loginForgotPassword" | translate }}
        </a>
      </nav>
    </div>
  </article>
</section>
